<script>
export default { inheritAttrs: false }
</script>

<script setup>
/**
 * DropdownItem — drop-in replacement for BV2's b-dropdown-item.
 *
 * Renders as <li><a class="dropdown-item">, passes through all attrs and listeners.
 * Automatically closes the parent Dropdown on click via inject.
 */
import { inject } from 'vue'

const closeDropdown = inject('closeDropdown', () => {})
</script>

<template>
    <li role="presentation">
        <a
            role="menuitem"
            class="dropdown-item"
            v-bind="$attrs"
            v-on="$listeners"
            @click="closeDropdown"
        >
            <slot />
        </a>
    </li>
</template>

<style scoped>
a {
    display: block;
    padding: 0.25rem 1.5rem;
    width: 100%;
}
</style>
